module.exports = __webpack_public_path__ + "img/didi-food.b19869da.png";